export const DE_DE = 'de-DE';
export const FR_FR = 'fr-FR';
export const EN_US = 'en-US';
export const ES_ES = 'es-ES';
